export function StreamLineIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_11659_1189)">
        <path
          d="M1.30176 1.30273V14.6982H14.6973"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.45108 4.68652C6.48443 4.68652 7.3221 5.52421 7.3221 6.55754C7.3221 7.59087 6.48443 8.42856 5.45108 8.42856C4.41775 8.42856 3.58008 7.59087 3.58008 6.55754C3.58008 5.52421 4.41775 4.68652 5.45108 4.68652Z"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.8261 1.55859C13.8594 1.55859 14.6971 2.39628 14.6971 3.42961C14.6971 4.46294 13.8594 5.30063 12.8261 5.30063C11.7928 5.30063 10.9551 4.46294 10.9551 3.42961C10.9551 2.39628 11.7928 1.55859 12.8261 1.55859Z"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.2255 8.42871C11.2588 8.42871 12.0965 9.26639 12.0965 10.2997C12.0965 11.333 11.2588 12.1707 10.2255 12.1707C9.19217 12.1707 8.35449 11.333 8.35449 10.2997C8.35449 9.26639 9.19217 8.42871 10.2255 8.42871Z"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.30176 10.5544L3.9717 7.70312"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.08301 7.49023L8.79506 9.08706"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0508 8.60992L12.2855 5.21875"
          stroke={props.color || '#4D4DFF'}
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11659_1189">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
